import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { HomeDailyLessonIcon } from './home_daily_lesson_icon';
export const HomeDailyLessonItemsGroup = ({ volumeColor, items, selectedItemKey, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) }, items.map((item, index) => {
        var _a, _b;
        return (React.createElement("div", { key: item.key, className: css(styles.itemRowWrapper, index > 0 && styles.itemRowWrapperOverlap) },
            React.createElement("div", { className: css(styles.itemRow, item.alignRight ? styles.itemRowRight : styles.itemRowLeft) },
                React.createElement(HomeDailyLessonIcon, { icon: item.icon, state: item.state, volumeColor: volumeColor, itemKey: item.key, isSelected: item.key === selectedItemKey, thumbnailUrl: (_b = (_a = item.day) === null || _a === void 0 ? void 0 : _a.dailyLessonDayLesson) === null || _b === void 0 ? void 0 : _b.lesson.thumbnailURL, onClick: item.onClick }))));
    })));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: 170,
        margin: '0 auto',
    },
    itemRowWrapper: {
        position: 'relative',
        width: '100%',
        overflow: 'visible',
        pointerEvents: 'none',
    },
    itemRowWrapperOverlap: {
        marginTop: -16,
    },
    itemRow: {
        position: 'relative',
        display: 'flex',
        width: 170,
        paddingLeft: 8,
        paddingRight: 8,
        overflow: 'visible',
        pointerEvents: 'none',
    },
    itemRowLeft: {
        justifyContent: 'flex-start',
    },
    itemRowRight: {
        justifyContent: 'flex-end',
    },
});
